import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  AddDependentRequest,
  DependentsResponse,
  UpdateDependentRequest,
} from './interfaces';
import { edupassClient, falconClient } from '@/data/@clients';
import {
  api_dependent_path,
  api_dependents_path,
  api_reset_password_dependent_path,
  api_update_dependent_path,
} from '@/utils/routes';

const queryKey = 'dependents';

export const useDependentsIndex = (collaboratorId?: number) => {
  const response = useQuery<DependentsResponse>({
    queryKey: [queryKey, collaboratorId],
    queryFn: async () =>
      edupassClient.get(`/colaboradores/${collaboratorId}/dependents`),
    enabled: !!collaboratorId,
  });

  return { dependents: response.data?.data, ...response };
};

export const useAddDependent = () => {
  const reactQuery = useQueryClient();
  return useMutation({
    mutationFn: async (data: AddDependentRequest) =>
      falconClient.post(api_dependents_path(), { dependent: data }),
    onSuccess: () => reactQuery.invalidateQueries({ queryKey: [queryKey] }),
  });
};

export const useUpdateDependent = () => {
  const reactQuery = useQueryClient();
  return useMutation({
    mutationFn: async (data: UpdateDependentRequest) =>
      falconClient.post(api_update_dependent_path({ id: data.id }), {
        dependent: data,
      }),
    onSuccess: () => reactQuery.invalidateQueries({ queryKey: [queryKey] }),
  });
};

export const useRemoveDependent = () => {
  const reactQuery = useQueryClient();
  return useMutation({
    mutationFn: async (id: number) =>
      falconClient.delete(api_dependent_path({ id })),
    onSuccess: () => reactQuery.invalidateQueries({ queryKey: [queryKey] }),
  });
};

export const useResetDependentPassword = () => {
  return useMutation({
    mutationFn: async (id: number) =>
      falconClient.post(api_reset_password_dependent_path({ id })),
  });
};
